import { createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-749648b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "myInfoContainer",
  class: "my-info-container"
}
const _hoisted_2 = { class: "my-info-view" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title--my-info" }, "회원 정보", -1 /* HOISTED */))
const _hoisted_4 = {
  class: "my-info",
  role: "list",
  "aria-label": "회원 정보 목록"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-title--notification" }, "알림", -1 /* HOISTED */))
const _hoisted_6 = { class: "notification-wrapper" }
const _hoisted_7 = { class: "info notification" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label",
  id: "notice-switch-label"
}, "중요알림 받기", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createVNode($setup["NavigationBar"], { title: "회원정보" }, {
        rightButton: _withCtx(() => [
          _createElementVNode("button", {
            class: "right-button",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goToMyInfoAuth($setup.RouterName.EditMyInfo)))
          }, " 수정 ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.userInfoFields, (field) => {
              return (_openBlock(), _createElementBlock("li", {
                key: field.key,
                role: "listitem"
              }, [
                ($setup.shouldShowMyInfoRow(field))
                  ? (_openBlock(), _createBlock($setup["MyInfoRow"], {
                      key: 0,
                      keyValue: field.key,
                      label: field.label,
                      value: $setup.getFieldValue(field)
                    }, null, 8 /* PROPS */, ["keyValue", "label", "value"]))
                  : _createCommentVNode("v-if", true)
              ]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          ($setup.shouldHaveNoticeConfig)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                _createElementVNode("section", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createVNode($setup["Switch"], {
                      class: "btn-switch",
                      initialStatus: $setup.noticeConfig,
                      "aria-labelledby": "notice-switch-label",
                      onOnClickSwitch: $setup.setNoticeConfig
                    }, null, 8 /* PROPS */, ["initialStatus"])
                  ])
                ])
              ], 64 /* STABLE_FRAGMENT */))
            : _createCommentVNode("v-if", true),
          _createElementVNode("button", {
            class: "btn-withdrawal",
            onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goToMyInfoAuth($setup.RouterName.WithDrawal)))
          }, " 회원탈퇴 ")
        ])
      ], 512 /* NEED_PATCH */),
      ($setup.myInfoContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.myInfoContainer
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}